import { useGetCurrencySymbol } from '@namespace/common';
import { PAYMENT_TYPES } from '../../constants';
import {
  STORE_PROPS,
  useGetPaymentService,
  usePaymentsStore
} from '../../store';

const { ACTIVE_PAYMENT_TYPE } = STORE_PROPS;

type LimitsWithCurrency = {
  min?: string;
  max?: string;
};

export const useGetServiceProperties = (withLimits = false) => {
  const activePaymentType = usePaymentsStore(ACTIVE_PAYMENT_TYPE);
  const isDeposit = activePaymentType === PAYMENT_TYPES.DEPOSIT;
  const {
    tax: { amount, type } = {},
    withdrawal = {},
    limits,
    currency
  } = useGetPaymentService();
  const getCurrencySymbol = useGetCurrencySymbol();
  const currencySymbol = getCurrencySymbol(currency);
  const { tax = {} } = withdrawal;
  const { amount: withdrawalAmount } = tax;
  const withdrawalFeeAmount = withdrawalAmount || amount;
  const feeAmount = isDeposit ? amount : withdrawalFeeAmount;
  const { min, max } = limits ?? {};
  const limitsWithCurrency = {
    min: min && currency && `${min} ${currencySymbol}`,
    max: max && currency && `${max} ${currencySymbol}`
  };

  return {
    amount: feeAmount,
    type: isDeposit ? type : '',
    min,
    max,
    limits: withLimits ? limitsWithCurrency : ({} as LimitsWithCurrency)
  };
};
